import type * as React from 'react';

function PremiumNFL(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="100%"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 20 28"
      width="27"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.3123 3.18544C18.4786 3.82253 16.8114 4.67198 14.7273 4.14107C11.0455 3.22083 10.0035 0 10.0035 0C10.0035 0 8.9545 3.21729 5.27961 4.14107C3.16429 4.67198 1.52831 3.81545 0.659951 3.18898H0V20.5319C0 20.992 0.104203 21.8415 0.802362 22.7263C1.66725 23.7881 3.12609 24.4712 5.14415 24.7686C6.77666 25.0057 7.95763 25.5224 8.79125 26.3471C9.41646 26.9523 10.0069 28 10.0069 28C10.0069 28 10.6148 26.9311 11.2088 26.3471C12.0493 25.5224 13.2407 25.0092 14.8559 24.7686C16.8774 24.4709 18.3293 23.7775 19.1976 22.7122C19.8958 21.8486 20 20.9814 20 20.5461V3.20314H19.3366"
        fill="white"
      />
      <path
        d="M19.3821 3.85831C19.3821 3.85831 17.3779 5.44749 14.554 4.72899C11.2647 3.89016 9.96908 1.38074 9.96908 1.38074C9.96908 1.38074 8.69086 3.8937 5.38415 4.72899C2.60541 5.43687 0.59082 3.84415 0.59082 3.84415V20.5146C0.591161 21.0809 0.82354 23.4877 5.24521 24.1248C6.9854 24.3814 8.28446 24.9495 9.20492 25.8661C9.54115 26.1946 9.79541 26.528 9.98992 26.8359C10.1855 26.5291 10.4415 26.1953 10.7749 25.8661C11.7093 24.9495 13.0083 24.3796 14.7346 24.1248C19.1459 23.4771 19.3543 21.0703 19.389 20.5146V3.84415"
        fill="#013369"
      />
      <path
        d="M10.005 25.1758C10.005 25.1758 11.2832 23.5689 14.5899 23.0486C18.4107 22.4505 18.2717 20.6312 18.2717 20.5392V11.7969H1.70348V20.5392C1.70348 20.6312 1.59094 22.4505 5.38531 23.0486C8.70591 23.5724 9.97024 25.1758 9.97024 25.1758"
        fill="white"
      />
      <path
        d="M6.11387 18.1917L6.11327 14.0507L5.60267 13.7587V12.6827H7.93334V13.7587L7.44706 14.0507V22.5098L6.20358 22.1311L4.40434 16.7158L4.40399 20.2906L4.97711 20.7365V21.8373L2.47971 21.1896V20.2516L3.05283 20.0237V14.0422L2.46582 13.7466V12.6707H4.35537L6.11987 18.1921"
        fill="#D50A0A"
      />
      <path
        d="M10.4197 21.9793L10.9199 22.5881V23.6641L8.44336 22.7226V21.8094L8.98869 21.5815V14.0426L8.44683 13.7627V12.6725H12.7539V14.8634H11.8091L11.5229 13.9644H10.4288V16.4986H11.2485L11.5715 16.0172H12.2315V18.2718H11.5715L11.2607 17.8152H10.427V21.9917"
        fill="#D50A0A"
      />
      <path
        d="M13.1649 22.3688V21.2928L13.7797 20.7796V14.0548L13.2552 13.7748V12.6847H15.7317V13.7748L15.2455 14.0548V20.3903L16.3118 20.0969L16.516 18.4404H17.5337V21.2082L13.1572 22.3975"
        fill="#D50A0A"
      />
      <path
        d="M2.13621 10.0164L1.38574 9.44302H2.30299L2.60561 8.55818L2.90823 9.44302H3.82547L3.075 10.0199L3.35087 10.9189L2.60387 10.3845L1.85687 10.9189L2.13274 10.0199"
        fill="white"
      />
      <path
        d="M5.38426 10.0164L4.63379 9.44302H5.55103L5.85365 8.55818L6.15627 9.44302H7.07352L6.32305 10.0199L6.59891 10.9189L5.85192 10.3845L5.10492 10.9189L5.38079 10.0199"
        fill="white"
      />
      <path
        d="M2.13621 7.04277L1.38574 6.46939H2.30299L2.60561 5.58455L2.90823 6.46939H3.82547L3.075 7.04631L3.35087 7.94531L2.60387 7.41087L1.85687 7.94531L2.13274 7.04631"
        fill="white"
      />
      <path
        d="M5.38426 7.04277L4.63379 6.46939H5.55103L5.85365 5.58455L6.15627 6.46939H7.07352L6.32305 7.04631L6.59891 7.94531L5.85192 7.41087L5.10492 7.94531L5.38079 7.04631"
        fill="white"
      />
      <path
        d="M18.1336 10.9014L17.3866 10.3669L16.6396 10.9014L16.9155 10.0024L16.165 9.42545H17.0823L17.3849 8.5406L17.6875 9.42545H18.6048L17.8543 10.0024L18.1305 10.9014"
        fill="white"
      />
      <path
        d="M14.8661 10.9014L14.1191 10.3669L13.3721 10.9014L13.6479 10.0024L12.8975 9.42545H13.8147L14.1173 8.5406L14.4203 9.42545H15.3375L14.5871 10.0024L14.8633 10.9014"
        fill="white"
      />
      <path
        d="M18.1336 7.92773L17.3866 7.39329L16.6396 7.92773L16.9155 7.02873L16.165 6.45181H17.0823L17.3849 5.56697L17.6875 6.45181H18.6048L17.8543 7.02873L18.1305 7.92773"
        fill="white"
      />
      <path
        d="M14.8661 7.92773L14.1191 7.39329L13.3721 7.92773L13.6479 7.02873L12.8975 6.45181H13.8147L14.1173 5.56697L14.4203 6.45181H15.3375L14.5871 7.02873L14.8633 7.92773"
        fill="white"
      />
      <path
        d="M10.6985 6.37034C10.3647 6.09002 9.98989 5.91022 9.59392 5.82174C9.69014 5.72901 9.78878 5.64937 9.87527 5.57575C10.372 5.69751 10.7054 5.92438 10.9347 6.11728C10.8534 6.20222 10.7745 6.28504 10.6999 6.36963L10.6985 6.37034ZM10.2157 6.96142C9.8975 6.68924 9.51056 6.48714 9.07291 6.39512C9.13994 6.30699 9.21844 6.21319 9.29382 6.12612C9.62865 6.18665 10.058 6.36645 10.4331 6.68181C10.3567 6.77525 10.2851 6.8701 10.2177 6.96035L10.2157 6.96142ZM9.78149 7.58081C9.43831 7.28952 9.03817 7.11007 8.64567 7.03574C8.64567 7.03574 8.7662 6.83542 8.83463 6.73171C9.31396 6.82869 9.70299 7.05733 9.97739 7.29093C9.90722 7.39287 9.84088 7.49055 9.78149 7.58045V7.58081ZM12.0496 4.62189C12.0496 4.62189 11.6606 4.82824 11.1188 5.37224C11.241 5.44267 11.3786 5.54107 11.4574 5.60796C11.3754 5.68193 11.2917 5.76192 11.2139 5.83696C10.8596 5.54071 10.4949 5.391 10.2101 5.32021C10.3046 5.25119 10.405 5.18323 10.504 5.1174C10.6568 5.15704 10.8048 5.21828 10.8048 5.21828C11.4161 4.744 11.9475 4.53871 11.9475 4.53871C11.9475 4.53871 11.886 4.50806 11.7224 4.51026C9.31535 4.54193 7.10278 6.37197 7.51959 9.50078C7.5644 9.83312 7.69118 10.4387 7.85234 10.7042C7.90583 10.1839 8.09826 9.03004 8.6686 7.79126C8.47027 7.7187 8.30736 7.68897 8.30736 7.68897C8.36572 7.56438 8.44665 7.40547 8.44665 7.40547C8.87041 7.48652 9.24206 7.66667 9.56509 7.9293C9.48763 8.05707 9.43519 8.14024 9.39802 8.20607C9.28479 8.11511 9.17016 8.03689 9.04373 7.9654C8.40115 9.10861 8.1059 10.1881 7.98433 10.7509C7.991 10.7857 8.06075 10.8036 8.11702 10.7962C10.7534 10.4483 11.9725 9.07605 12.3546 7.59305C12.6016 6.61973 12.5206 5.60038 12.19 4.76863C12.1667 4.71023 12.1215 4.61326 12.0448 4.62033"
        fill="white"
      />
    </svg>
  );
}

export default PremiumNFL;
